const VARIANT_CLASSES = {
  page: "flex min-h-[100dvh] items-center justify-center bg-[var(--bg)] px-4",
  section: "flex min-h-40 items-center justify-center px-4 py-8",
  inline: "inline-flex items-center justify-center",
};

export function LoadingSpinner({ size = "md", className = "" }) {
  const sizeClass = size === "sm" ? "h-4 w-4 border-2" : "h-5 w-5 border-2";
  return (
    <span
      className={`${sizeClass} shrink-0 animate-spin rounded-full border-[var(--border)] border-t-[var(--brand)] ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export default function LoadingState({
  message = "Loading...",
  detail = "",
  variant = "section",
  className = "",
  showMessage = true,
}) {
  const isInline = variant === "inline";
  const Wrapper = isInline ? "span" : "div";

  return (
    <Wrapper
      className={`${VARIANT_CLASSES[variant] || VARIANT_CLASSES.section} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className={`flex ${isInline ? "items-center gap-2" : "max-w-sm flex-col items-center text-center"}`}>
        <LoadingSpinner size={isInline ? "sm" : "md"} />
        {showMessage ? (
          <span className={isInline ? "text-sm font-medium" : "mt-3 text-sm font-semibold text-[var(--fg-primary)]"}>
            {message}
          </span>
        ) : (
          <span className="sr-only">{message}</span>
        )}
        {showMessage && !isInline && detail ? (
          <span className="mt-1 text-sm leading-5 text-[var(--muted)]">{detail}</span>
        ) : null}
      </span>
    </Wrapper>
  );
}
